import { createActions } from 'redux-actions';
import {
  apiActions as commonApiActions,
  apiResourceActionCreator,
  endpointQuery
} from '../../common';

export const API_ENDPOINT = 'publisher/content';

const actions = createActions({
  PUBLISHER_PORTAL: {
    CONTENT: {
      API: {
        GET: apiResourceActionCreator('contentResult'),
        GET_BY_ID: apiResourceActionCreator('content'),
        ADD_CONTENT: apiResourceActionCreator('content'),
        UPDATE_CONTENT: apiResourceActionCreator('content'),
        LOAD_MORE: apiResourceActionCreator('contentResult'),
        ADD_QUESTION: apiResourceActionCreator('question'),
        UPDATE_QUESTION: apiResourceActionCreator('question'),
        DELETE_QUESTION: apiResourceActionCreator('deleted'),
        GET_CONTENT_QUESTIONS: apiResourceActionCreator('questions'),
        DELETE_CONTENT: apiResourceActionCreator('deletedId'),
        GET_CONTENT_PASSED_USER_EMAILS: apiResourceActionCreator('passedUserEmails')
      },
      GET: (skip, query) => ({ skip, query }),
      GET_BY_ID: (contentId) => ({ contentId }),
      RESET_SELECTED_CONTENT: undefined,
      SAVE_CONTENT: (content, nextRoute) => ({ content, nextRoute }),
      LOAD_MORE: (skip, query) => ({ skip, query }),
      SAVE_QUESTION: (questionData) => ({ questionData }),
      DELETE_QUESTION: (contentId, questionId) => ({ contentId, questionId }),
      GET_CONTENT_QUESTIONS: (contentId) => ({ contentId }),
      DELETE_CONTENT: (contentId, contentQuery) => ({ contentId, contentQuery }),
      GET_CONTENT_PASSED_USER_EMAILS: (contentId) => ({ contentId }),
    }
  }
});

export const apiActions = {
  publisherPortal: {
    content: {
      get: (authToken, skip, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}${endpointQuery({ ...(query || {}), skip })}`, authToken, actions.publisherPortal.content.api.get),
      getById: (authToken, contentId) => commonApiActions.authenticated.get(`${API_ENDPOINT}/${contentId}`, authToken, actions.publisherPortal.content.api.getById),
      addContent: (authToken, formData) => commonApiActions.authenticated.postFormData(`${API_ENDPOINT}`, authToken, formData, actions.publisherPortal.content.api.addContent),
      updateContent: (authToken, formData) => commonApiActions.authenticated.putFormData(`${API_ENDPOINT}/${formData.data.content.id}`, authToken, formData, actions.publisherPortal.content.api.updateContent),
      loadMore: (authToken, skip, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}${endpointQuery({ ...(query || {}), skip })}`, authToken, actions.publisherPortal.content.api.loadMore),
      deleteContent: (authToken, contentId) => commonApiActions.authenticated.delete(`${API_ENDPOINT}/${contentId}`, authToken, actions.publisherPortal.content.api.deleteContent),

      // Content Questions.
      addQuestion: (authToken, contentId, payload) => commonApiActions.authenticated.postFormData(`${API_ENDPOINT}/${contentId}/questions`, authToken, payload, actions.publisherPortal.content.api.addQuestion),
      updateQuestion: (authToken, contentId, questionId, payload) => commonApiActions.authenticated.putFormData(`${API_ENDPOINT}/${contentId}/questions/${questionId}`, authToken, payload, actions.publisherPortal.content.api.updateQuestion),
      deleteQuestion: (authToken, contentId, questionId) => commonApiActions.authenticated.delete(`${API_ENDPOINT}/${contentId}/questions/${questionId}`, authToken, actions.publisherPortal.content.api.deleteQuestion),
      getContentQuestions: (authToken, contentId) => commonApiActions.authenticated.get(`${API_ENDPOINT}/${contentId}/questions`, authToken, actions.publisherPortal.content.api.getContentQuestions),

      // Content Users.
      getContentPassedUserEmails: (authToken, contentId) => commonApiActions.authenticated.get(`${API_ENDPOINT}/${contentId}/passed-user-emails`, authToken, actions.publisherPortal.content.api.getContentPassedUserEmails)
    }
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/content/actions.js